import { api } from '@/core/api/';

const baseApiURL = 'api/proposal/documentconfiguration';

export const getInitFilters = () => api.get(`${baseApiURL}/initfilters`);

export const getInitDataToCreation = () =>
  api.get(`${baseApiURL}/initDataToCreation`);

export const search = (payload) =>
  api.get(`${baseApiURL}/search`, {
    params: payload,
  });

export const getDetail = (documentConfigurationId) =>
  api.get(`${baseApiURL}/detail/${documentConfigurationId}`);

export const create = (academicYearId, areaId, recruitmentTypeId) =>
  api.post(
    `${baseApiURL}/create/${academicYearId}/${areaId}/${recruitmentTypeId}`
  );

export const deleteDocument = (proposalDocumentTypeId) =>
  api.delete(`${baseApiURL}/deletedocument/${proposalDocumentTypeId}`);

export const updateDocument = (payload) =>
  api.put(`${baseApiURL}/updatedocument`, payload);

export const getDocumentTypes = (configurationId) =>
  api.get(`${baseApiURL}/documenttypes/${configurationId}`);

export const addDocument = (payload) =>
  api.post(`${baseApiURL}/adddocument`, payload);

export const reorderDocuments = (payload) =>
  api.put(`${baseApiURL}/reorderdocuments`, payload);
